import { combineReducers } from 'redux';
import { produce } from 'immer';
import { editorSlice } from 'app/stores/editor';
import { getProjectState, projectSlice } from 'app/stores/project';
import { publishSlice } from 'app/stores/publish';
import { viewportSlice } from 'app/stores/viewport';
import { undoableNew } from './history/undoable';
function composeReducers(reducer, extraReducers) {
    const reducers = [reducer, ...extraReducers];
    return (state, action) => reducers.reduce((currentState, currentReducer) => currentReducer(currentState, action), state);
}
export function getReducer() {
    const combinedReducer = combineReducers({
        editor: editorSlice.reducer,
        viewport: viewportSlice.reducer,
        project: undoableNew(projectSlice.reducer, [
            'page',
            'pages',
            'images',
            'markers',
            'activePage',
            'size',
            'color',
        ]),
        publish: publishSlice.reducer,
    });
    const applicationReducer = composeReducers(combinedReducer, [
        (state, action) => {
            switch (action.type) {
                case editorSlice.actions.setTool.type: {
                    return produce(state, draft => {
                        var _a;
                        const { editor: editorState } = draft;
                        const projectState = getProjectState(state);
                        if (configGet('saveColorPerTool', false)) {
                            const { activeTool, markerColor } = editorState;
                            if (activeTool && markerColor[activeTool]) {
                                markerColor.lastUsedColor = projectState.color;
                                projectState.color = markerColor[activeTool];
                            }
                            else {
                                projectState.color =
                                    (_a = markerColor.lastUsedColor) !== null && _a !== void 0 ? _a : projectState.color;
                                delete markerColor.lastUsedColor;
                            }
                        }
                        return draft;
                    });
                }
                default:
                    return state;
            }
        },
    ]);
    // const rootReducer = createUndoable(
    //     applicationReducer,
    //     ['project'],
    //     {
    //         project: {
    //             keys: ['hovered', 'selection', 'color', 'size'],
    //             type: 'ignore',
    //         },
    //     },
    //     { setLocked: true }
    // );
    return applicationReducer;
}
